/**
 * CSV アップロード Step2 の確定可否と「処理対象 0 件」バナー表示の判定
 * (common.md AC-DUC-033 / AC-DUC-015)。
 *
 * 処理対象は AC-DUC-033 の定義どおり 新規+変更+削除 の行数。エラー行があれば
 * 確定不可、処理対象 0 件でも確定不可、noop バナーはエラーが理由でない時だけ出す
 * (design `#error-banner` / `#noop-banner` の排他)。
 *
 * 件数が無い (= プレビュー・チェック結果が未取得) 時も判定側で確定不可・バナー
 * 非表示にする — 未取得を 0 件として渡させると、呼び出し側がガードを 1 つ
 * 付け忘れるだけでプレビュー前に 0 件バナーが出るため。
 */
export type CsvUploadConfirmGate = {
  canOpenConfirm: boolean
  showNoRowsToProcessBanner: boolean
}

export type CsvUploadRowCounts = {
  newRowCount: number
  changedRowCount: number
  deletedRowCount: number
}

export function resolveCsvUploadConfirmGate(
  counts: CsvUploadRowCounts | undefined,
  hasErrorRows: boolean,
): CsvUploadConfirmGate {
  if (counts === undefined) {
    return { canOpenConfirm: false, showNoRowsToProcessBanner: false }
  }
  const processableRowCount =
    counts.newRowCount + counts.changedRowCount + counts.deletedRowCount
  const hasProcessableRows = processableRowCount > 0
  return {
    canOpenConfirm: !hasErrorRows && hasProcessableRows,
    showNoRowsToProcessBanner: !hasErrorRows && !hasProcessableRows,
  }
}
